import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import CompleteModal from '../../../../../components/CompleteModal/CompleteModal';
import messages from '../../messages';

const CompleteView = ({ onComplete }: { onComplete: () => void }) => {
  const { language } = useSelector((state: RootState) => state.language);

  const viewMessages = messages[language].complete;

  return (
    <div>
      <CompleteModal
        heading={viewMessages.heading}
        subheading={viewMessages.subheading}
        continueButton={viewMessages.continueButton}
        onComplete={onComplete}
      />
    </div>
  );
};

export default CompleteView;
